// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Navbar Styles */
.ant-menu-light.ant-menu-horizontal > .ant-menu-item-selected::after {
  display: none;
}

.ant-menu-light.ant-menu-horizontal > .ant-menu-item-selected::after {
  display: none;
}

.ant-menu-light.ant-menu-horizontal > .ant-menu-item:hover::after {
  border-bottom: none;
  border-color: none;
}
.ant-menu-light.ant-menu-horizontal > .ant-menu-item-selected::after {
  border-bottom: none;
  border-color: none;
}
.ant-menu-light.ant-menu-horizontal > .ant-menu-item-selected::before {
  border-bottom: none;
  border-color: none;
}

.ant-menu-light.ant-menu-horizontal > .ant-menu-item:hover::before {
  border-bottom: none;
  border-color: none;
}

.ant-menu-item-active {
  color: none !important;
}
.get-in-touch-nav {
  cursor: pointer;
}

.ant-drawer .ant-drawer-header {
  border-bottom: none !important;
}

.ant-menu-light.ant-menu-horizontal > .ant-menu-item-active::after {
  border-bottom-color: transparent !important;
  border-block-width: 0 !important;
}

.navbar-container {
  width: 100%;
  position: sticky !important;
  background-color: white !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 1000 !important;
  border-bottom: 1px solid #f3f4f6;
  /* box-shadow: 0px 1px 2px -1px #0000001a;
  box-shadow: 0px 1px 3px 0px #0000001a; */
}
.nav-main-profile-image-initials-avatar {
  background-color: #d2042d !important;
  color: #fff !important;
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50% !important;
  width: 32px !important;
  height: 32px !important;
  font-size: 14px !important;
}
.user-badge-image-div {
  display: flex;
  align-items: center;
  padding-right: 15px;
}
.profile-image-dropdown {
  width: 4.3rem !important;
  height: auto !important;
}
.user-navbar-mobile-image-col {
  display: flex;
  justify-content: center;
  align-items: center;
}
.navbar-row {
  height: 80px;
  background-color: white;
  padding: 10px 2.3rem !important;
  justify-content: space-between !important;
}

.navbar-logo {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  /* padding-left: 4rem !important; */
}

.logo-red {
  filter: invert(11%) sepia(92%) saturate(7500%) hue-rotate(355deg)
    brightness(92%) contrast(105%);
  height: 60px !important;
  width: 130px !important;
}
.chat-notification-icons {
  cursor: pointer;
}
.navbar-menu {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.navbar-menu-items {
  border-bottom: none;
  display: flex;
  justify-content: space-evenly;
  width: 100%;
}

.menu-item {
  position: relative;
}

.menu-link {
  font-family: Roboto;
  color: black;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
}

.menu-link.active {
  color: #d2042d;
  /* font-weight: bold; */
}
.action-icons {
  cursor: pointer;
}

.active-indicator {
  position: absolute;
  bottom: -1px;
  left: 50%;
  transform: translateX(-50%);
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #d2042d;
}

.user-actions-bar {
  display: flex;
  align-items: center;
}

.navbar-link-RFP-btn {
  font-family: Roboto;
  color: #d2042d;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.navbar-actions-cont {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.navbar-link {
  font-family: Roboto;
  color: #d2042d;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.navbar-text:hover {
  background-color: #d2042d !important;
  color: #fff !important;
  box-shadow: none !important;
  border: none !important;
  cursor: pointer;
  outline: #d2042d;
}

.navbar-text {
  font-family: Roboto;
  background-color: #d2042d;
  color: #fff;
  border: none;
  padding: 8px 34px;
  font-weight: 600;
  align-items: center;
  height: 35px;
  font-size: 1rem;
}
.navbar-actions-with-rfp {
  display: flex;
  align-items: center;
  gap: 4%;
  justify-content: flex-end;
}

.navbar-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4%;
  justify-content: flex-end;
}

.profile-section {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}
.profile-section-main-div {
  display: flex !important;
  gap: 0.5rem !important;
}
.profile-avatar {
  background-color: #d2042d !important;
  color: #fff !important;
}
.messages-menu-wrapper {
  position: relative;
  display: inline-block;
}
.messages-count-badge {
  position: absolute;
  top: 7px;
  right: -20px;
}
.close-drawer-outline {
  display: flex !important;
  justify-content: end !important;
}
.submit-your-rfp-heading {
  display: flex;
  height: 50px !important;
  background-color: #f7f7f7 !important;
  justify-content: space-around !important;
  align-items: center !important;
}
.submit-rfp-back-button {
  padding-right: 1rem !important;
  padding-top: 1rem !important;
  display: flex !important;
  gap: 0.5rem !important;
  align-items: center !important;
}
.nav-profile-image {
  width: 4rem !important;
  height: 4rem !important;
  border-radius: 50%;
}
.nav-main-profile-image {
  width: 2rem !important;
  height: 2rem !important;
  border-radius: 50%;
  overflow: hidden;
}
.profile-details {
  display: flex;
  flex-direction: column;
}
.align-section {
  padding-top: 0.5rem;
}
.profile-email {
  color: var(--Colors-Text-200, #8e9190);
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 400;
  font-family: Roboto;

  line-height: normal;
}

.profile-name {
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  font-family: Roboto;
}
.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  display: inline-block;
}
.edit-profile {
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
}

.basic-plan-container {
  display: flex;
  margin-top: 2%;
  width: 17.4375rem;
  height: 3.5rem;
  flex-shrink: 0;
  border-radius: 0.3125rem;
  background: #ffe9ed;
  margin-bottom: 4%;
}

.basic-plan-details-div {
  display: flex;
  gap: 2%;
  flex-direction: column;
  padding: 12px;
}

.basic-plan-text {
  color: #000;
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.limited-campaign-text {
  color: #a0a0a0;
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.basic-plan-upgrade-div {
  display: inline-flex;
  height: 1.75rem;
  padding: 1.7rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}
.basic-plan-upgrade-btn {
  display: inline-flex;
  height: 1.75rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  border-radius: 0.3125rem;
  background: var(--Colors-Primary-500, #d2042d);
  border-color: none !important;
}
.basic-plan-upgrade-btn:hover {
  border-color: #d2042d !important;
  background: var(--Colors-Primary-500, #d2042d) !important;
}
.basic-plan-upgrade-btn-text {
  color: #fff;
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.ant-dropdown .ant-dropdown-menu {
  margin-top: 1% !important;
}
.user-details-popover .ant-dropdown-menu {
  overflow-x: clip;
}
.personal-details-menu-list {
  display: flex;
  width: 15.9375rem;
  height: 2.75rem;
  align-items: center;
  font-family: Roboto;

  gap: 0.5rem;
}

.profile-image-container {
  display: inline-flex;
  padding: 0.25rem 0.9375rem 0.25rem 0.375rem;
  align-items: center;
  gap: 0.3rem;
  border-radius: 2.5rem;
  background: #f1f0f0;
  cursor: pointer;
}

.personal-details-icons {
  display: flex;
  width: 1.25rem;
  height: 1.25rem;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}
.details-dropdown
  :where(.css-dev-only-do-not-override-1d4w9r2).ant-dropdown
  .ant-dropdown-menu
  .ant-dropdown-menu-item-icon {
  min-width: 30px;
  margin-inline-end: 12px;
  font-size: 20px;
  color: black !important;
}

.personal-details-menu-list {
  color: var(--Foreground, #0a0f0d);
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  font-family: Roboto;
}
/* .personal-details-menu-list:hover {
  color: #fff !important;
  background-color: #d2042d !important;
} */
.enquiry-menu-chat-icon {
  display: flex;
  width: 1.25rem;
  height: 1.25rem;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  fill: black !important;
  color: #000 !important;
}
.submit-your-request-nav-bar {
  color: #000;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-small, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.notification-title {
  display: flex;
  justify-content: space-between;
}
.notification-title .header {
  color: #000;
  font-size: var(--Font-Font-Size-h5, 17px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.notificationPopover .ant-popover-inner {
  width: 350px;
  max-height: 667px;
  overflow-y: scroll;
}
.see-all-link {
  font-weight: 500;
  font-size: 1rem;
  line-height: 100%;
  letter-spacing: 0%;
  text-decoration: underline;
  text-decoration-style: solid;
  color: #d2042d;
}

@media (max-width: 1024px) {
  .ant-menu-light .ant-menu-item-selected {
    color: #d2042d;
  }
  .ant-menu-light .ant-menu-item-selected {
    background-color: #eadada;
  }
  .navbar-container .ant-drawer .ant-drawer-header-title {
    justify-content: flex-end;
    height: 24px;
    width: 24px;
  }

  .navbar-logo {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .navbar-menu-items {
    border-bottom: none;
    display: flex;
    justify-content: space-evenly !important;
    width: 100%;
  }

  .navbar-actions-cont {
    display: flex;
    flex-direction: row;
    justify-content: flex-start !important;
    align-items: flex-start !important;
  }

  .navbar-link-RFP-btn {
    color: #d2042d;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-right: 0px !important;
  }

  .active-indicator {
    position: absolute;
    bottom: -7px;
    left: 50%;
    transform: translateX(-50%);
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #d2042d;
  }

  .logo-red {
    filter: invert(11%) sepia(92%) saturate(7500%) hue-rotate(355deg)
      brightness(92%) contrast(105%);
    height: 50px !important;
    width: 140px !important;
  }

  .submit-rfp-container {
    margin-top: 10px;
  }

  .navbar-text {
    background-color: #d2042d;
    color: white;
    border: none;
    font-weight: 600;
    width: 100px;
    height: 40px;
    margin-right: 0vh;
    font-size: 1rem;
  }
  .navbar-actions-with-rfp {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .navbar-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 0px !important;
  }

  .navbar-row {
    height: auto;
    padding: 10px 2rem !important;
  }

  .navbar-mobile {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .ant-drawer .ant-drawer-body {
    padding: 0px;
  }

  .menu-icon {
    font-size: xx-large;
  }

  .login-icon {
    font-size: large;
  }

  .navbar-logo {
    span: 12;
  }

  .navbar-menu-items {
    color: var(--Colors-Text-500, #0a0f0d);
    font-size: var(--Font-Font-Size-h5, 16px);
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .user-actions-bar {
    display: flex;
    padding-left: 33px !important;
    align-items: flex-end !important;
  }

  .navbar-login-btn {
    width: 100%;
    margin-top: 10px;
  }

  .action-icons {
    height: 23px !important;
    width: 23px !important;
  }

  .navbar-link {
    color: #d2042d;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .menu-link {
    font-size: 1rem;
  }
}

.navbar-div {
  display: flex;
  gap: 0.5rem;
}

.navbar-avatar {
  background: #d2042d;
  color: #fff;
}
.navbar-drawer {
  display: flex;
  justify-content: end;
}

.navbar-actions-row {
  height: 50px;
  background-color: #f7f7f7;
}

.navbar-back-button {
  padding-left: 1rem;
  padding-top: 1rem;
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.custom-advertise-modal.ant-modal .ant-modal-content {
  padding: 0px !important;
}

@media (max-width: 576px) {
  .navbar-menu-items {
    font-size: 14px;
  }

  .navbar-actions {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .navbar-text {
    font-size: 0.75rem;
  }

  .navbar-login-btn {
    font-size: 0.875rem;
  }

  .menu-link {
    font-size: 1rem;
  }

  .menu-icon {
    font-size: large;
  }

  .navbar-logo {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 1rem;
  }

  .login-icon {
    font-size: large;
    width: 30px;
  }
  .navbar-container {
    width: 100%;
    position: sticky !important;
    background-color: white !important;
    top: 0 !important;
    left: 0 !important;
    z-index: 1000 !important;
    height: 81px;
  }
}
@media (max-width: 768px) {
  .navbar-logo {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 2rem !important;
  }
}
@media (max-width: 375px) {
  .submit-your-request-nav-bar {
    color: #000;
    font-family: Roboto;
    font-size: var(--Font-Font-Size-small, 15px) !important;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .navbar-link {
    color: #d2042d;
    font-size: 16px !important;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
}
@media (max-width: 320px) {
  .navbar-logo {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 0.5rem !important;
  }
}
.rfp-input-field {
  height: 3.125rem;
  padding: 0.625rem 1.25rem !important;
  align-items: center;
  margin-top: 0;
  font-size: 14px;
  border-radius: 0.3125rem !important;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;
  background: #fcfcfc !important;
}

.ant-menu-light.ant-menu-root:focus-visible {
  outline: unset;
  outline-offset: 1px;
  transition:
    outline-offset 0s,
    outline 0s;
}

@media (min-width: 1025px) {
  .navbar-row {
    padding: 10px 4.37rem !important;
  }
}

.chatbox-modal-desktop .ant-drawer .ant-drawer-body {
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  padding: 12px 12px !important;
  overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/navbar/NavBar.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;EAChC;0CACwC;AAC1C;AACA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE;kCACgC;EAChC,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,OAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;;EAEnB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,yCAAyC;EACzC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,8CAA8C;EAC9C,6BAA6B;AAC/B;AACA;EACE,gCAAgC;EAChC,yDAAyD;AAC3D;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;;EAEnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;;;;EAIE,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;;GAGG;AACH;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,kCAAkC;EACpC;;EAEA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE;oCACgC;IAChC,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,sCAAsC;IACtC,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,WAAW;IACX,2BAA2B;IAC3B,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,wBAAwB;IACxB,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,WAAW;IACX,mBAAmB;IACnB,uDAAuD;IACvD,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,+BAA+B;EACjC;AACF;AACA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mCAAmC;EACnC,mEAAmE;EACnE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB;;cAEY;AACd;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,cAAc;AAChB","sourcesContent":["/* Base Navbar Styles */\n.ant-menu-light.ant-menu-horizontal > .ant-menu-item-selected::after {\n  display: none;\n}\n\n.ant-menu-light.ant-menu-horizontal > .ant-menu-item-selected::after {\n  display: none;\n}\n\n.ant-menu-light.ant-menu-horizontal > .ant-menu-item:hover::after {\n  border-bottom: none;\n  border-color: none;\n}\n.ant-menu-light.ant-menu-horizontal > .ant-menu-item-selected::after {\n  border-bottom: none;\n  border-color: none;\n}\n.ant-menu-light.ant-menu-horizontal > .ant-menu-item-selected::before {\n  border-bottom: none;\n  border-color: none;\n}\n\n.ant-menu-light.ant-menu-horizontal > .ant-menu-item:hover::before {\n  border-bottom: none;\n  border-color: none;\n}\n\n.ant-menu-item-active {\n  color: none !important;\n}\n.get-in-touch-nav {\n  cursor: pointer;\n}\n\n.ant-drawer .ant-drawer-header {\n  border-bottom: none !important;\n}\n\n.ant-menu-light.ant-menu-horizontal > .ant-menu-item-active::after {\n  border-bottom-color: transparent !important;\n  border-block-width: 0 !important;\n}\n\n.navbar-container {\n  width: 100%;\n  position: sticky !important;\n  background-color: white !important;\n  top: 0 !important;\n  left: 0 !important;\n  z-index: 1000 !important;\n  border-bottom: 1px solid #f3f4f6;\n  /* box-shadow: 0px 1px 2px -1px #0000001a;\n  box-shadow: 0px 1px 3px 0px #0000001a; */\n}\n.nav-main-profile-image-initials-avatar {\n  background-color: #d2042d !important;\n  color: #fff !important;\n  display: flex;\n  align-items: center !important;\n  justify-content: center !important;\n  border-radius: 50% !important;\n  width: 32px !important;\n  height: 32px !important;\n  font-size: 14px !important;\n}\n.user-badge-image-div {\n  display: flex;\n  align-items: center;\n  padding-right: 15px;\n}\n.profile-image-dropdown {\n  width: 4.3rem !important;\n  height: auto !important;\n}\n.user-navbar-mobile-image-col {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.navbar-row {\n  height: 80px;\n  background-color: white;\n  padding: 10px 2.3rem !important;\n  justify-content: space-between !important;\n}\n\n.navbar-logo {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  /* padding-left: 4rem !important; */\n}\n\n.logo-red {\n  filter: invert(11%) sepia(92%) saturate(7500%) hue-rotate(355deg)\n    brightness(92%) contrast(105%);\n  height: 60px !important;\n  width: 130px !important;\n}\n.chat-notification-icons {\n  cursor: pointer;\n}\n.navbar-menu {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.navbar-menu-items {\n  border-bottom: none;\n  display: flex;\n  justify-content: space-evenly;\n  width: 100%;\n}\n\n.menu-item {\n  position: relative;\n}\n\n.menu-link {\n  font-family: Roboto;\n  color: black;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.menu-link.active {\n  color: #d2042d;\n  /* font-weight: bold; */\n}\n.action-icons {\n  cursor: pointer;\n}\n\n.active-indicator {\n  position: absolute;\n  bottom: -1px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: #d2042d;\n}\n\n.user-actions-bar {\n  display: flex;\n  align-items: center;\n}\n\n.navbar-link-RFP-btn {\n  font-family: Roboto;\n  color: #d2042d;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.navbar-actions-cont {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.navbar-link {\n  font-family: Roboto;\n  color: #d2042d;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.navbar-text:hover {\n  background-color: #d2042d !important;\n  color: #fff !important;\n  box-shadow: none !important;\n  border: none !important;\n  cursor: pointer;\n  outline: #d2042d;\n}\n\n.navbar-text {\n  font-family: Roboto;\n  background-color: #d2042d;\n  color: #fff;\n  border: none;\n  padding: 8px 34px;\n  font-weight: 600;\n  align-items: center;\n  height: 35px;\n  font-size: 1rem;\n}\n.navbar-actions-with-rfp {\n  display: flex;\n  align-items: center;\n  gap: 4%;\n  justify-content: flex-end;\n}\n\n.navbar-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 4%;\n  justify-content: flex-end;\n}\n\n.profile-section {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n.profile-section-main-div {\n  display: flex !important;\n  gap: 0.5rem !important;\n}\n.profile-avatar {\n  background-color: #d2042d !important;\n  color: #fff !important;\n}\n.messages-menu-wrapper {\n  position: relative;\n  display: inline-block;\n}\n.messages-count-badge {\n  position: absolute;\n  top: 7px;\n  right: -20px;\n}\n.close-drawer-outline {\n  display: flex !important;\n  justify-content: end !important;\n}\n.submit-your-rfp-heading {\n  display: flex;\n  height: 50px !important;\n  background-color: #f7f7f7 !important;\n  justify-content: space-around !important;\n  align-items: center !important;\n}\n.submit-rfp-back-button {\n  padding-right: 1rem !important;\n  padding-top: 1rem !important;\n  display: flex !important;\n  gap: 0.5rem !important;\n  align-items: center !important;\n}\n.nav-profile-image {\n  width: 4rem !important;\n  height: 4rem !important;\n  border-radius: 50%;\n}\n.nav-main-profile-image {\n  width: 2rem !important;\n  height: 2rem !important;\n  border-radius: 50%;\n  overflow: hidden;\n}\n.profile-details {\n  display: flex;\n  flex-direction: column;\n}\n.align-section {\n  padding-top: 0.5rem;\n}\n.profile-email {\n  color: var(--Colors-Text-200, #8e9190);\n  font-size: 0.8125rem;\n  font-style: normal;\n  font-weight: 400;\n  font-family: Roboto;\n\n  line-height: normal;\n}\n\n.profile-name {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  font-family: Roboto;\n}\n.truncate-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 200px;\n  display: inline-block;\n}\n.edit-profile {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 0.8125rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  cursor: pointer;\n}\n\n.basic-plan-container {\n  display: flex;\n  margin-top: 2%;\n  width: 17.4375rem;\n  height: 3.5rem;\n  flex-shrink: 0;\n  border-radius: 0.3125rem;\n  background: #ffe9ed;\n  margin-bottom: 4%;\n}\n\n.basic-plan-details-div {\n  display: flex;\n  gap: 2%;\n  flex-direction: column;\n  padding: 12px;\n}\n\n.basic-plan-text {\n  color: #000;\n  font-size: 0.8125rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.limited-campaign-text {\n  color: #a0a0a0;\n  font-size: 0.8125rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.basic-plan-upgrade-div {\n  display: inline-flex;\n  height: 1.75rem;\n  padding: 1.7rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n.basic-plan-upgrade-btn {\n  display: inline-flex;\n  height: 1.75rem;\n  padding: 0.5rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  border-radius: 0.3125rem;\n  background: var(--Colors-Primary-500, #d2042d);\n  border-color: none !important;\n}\n.basic-plan-upgrade-btn:hover {\n  border-color: #d2042d !important;\n  background: var(--Colors-Primary-500, #d2042d) !important;\n}\n.basic-plan-upgrade-btn-text {\n  color: #fff;\n  font-size: 0.8125rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.ant-dropdown .ant-dropdown-menu {\n  margin-top: 1% !important;\n}\n.user-details-popover .ant-dropdown-menu {\n  overflow-x: clip;\n}\n.personal-details-menu-list {\n  display: flex;\n  width: 15.9375rem;\n  height: 2.75rem;\n  align-items: center;\n  font-family: Roboto;\n\n  gap: 0.5rem;\n}\n\n.profile-image-container {\n  display: inline-flex;\n  padding: 0.25rem 0.9375rem 0.25rem 0.375rem;\n  align-items: center;\n  gap: 0.3rem;\n  border-radius: 2.5rem;\n  background: #f1f0f0;\n  cursor: pointer;\n}\n\n.personal-details-icons {\n  display: flex;\n  width: 1.25rem;\n  height: 1.25rem;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n}\n.details-dropdown\n  :where(.css-dev-only-do-not-override-1d4w9r2).ant-dropdown\n  .ant-dropdown-menu\n  .ant-dropdown-menu-item-icon {\n  min-width: 30px;\n  margin-inline-end: 12px;\n  font-size: 20px;\n  color: black !important;\n}\n\n.personal-details-menu-list {\n  color: var(--Foreground, #0a0f0d);\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  font-family: Roboto;\n}\n/* .personal-details-menu-list:hover {\n  color: #fff !important;\n  background-color: #d2042d !important;\n} */\n.enquiry-menu-chat-icon {\n  display: flex;\n  width: 1.25rem;\n  height: 1.25rem;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  fill: black !important;\n  color: #000 !important;\n}\n.submit-your-request-nav-bar {\n  color: #000;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-small, 16px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.notification-title {\n  display: flex;\n  justify-content: space-between;\n}\n.notification-title .header {\n  color: #000;\n  font-size: var(--Font-Font-Size-h5, 17px);\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.notificationPopover .ant-popover-inner {\n  width: 350px;\n  max-height: 667px;\n  overflow-y: scroll;\n}\n.see-all-link {\n  font-weight: 500;\n  font-size: 1rem;\n  line-height: 100%;\n  letter-spacing: 0%;\n  text-decoration: underline;\n  text-decoration-style: solid;\n  color: #d2042d;\n}\n\n@media (max-width: 1024px) {\n  .ant-menu-light .ant-menu-item-selected {\n    color: #d2042d;\n  }\n  .ant-menu-light .ant-menu-item-selected {\n    background-color: #eadada;\n  }\n  .navbar-container .ant-drawer .ant-drawer-header-title {\n    justify-content: flex-end;\n    height: 24px;\n    width: 24px;\n  }\n\n  .navbar-logo {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n  }\n\n  .navbar-menu-items {\n    border-bottom: none;\n    display: flex;\n    justify-content: space-evenly !important;\n    width: 100%;\n  }\n\n  .navbar-actions-cont {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start !important;\n    align-items: flex-start !important;\n  }\n\n  .navbar-link-RFP-btn {\n    color: #d2042d;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    margin-right: 0px !important;\n  }\n\n  .active-indicator {\n    position: absolute;\n    bottom: -7px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background-color: #d2042d;\n  }\n\n  .logo-red {\n    filter: invert(11%) sepia(92%) saturate(7500%) hue-rotate(355deg)\n      brightness(92%) contrast(105%);\n    height: 50px !important;\n    width: 140px !important;\n  }\n\n  .submit-rfp-container {\n    margin-top: 10px;\n  }\n\n  .navbar-text {\n    background-color: #d2042d;\n    color: white;\n    border: none;\n    font-weight: 600;\n    width: 100px;\n    height: 40px;\n    margin-right: 0vh;\n    font-size: 1rem;\n  }\n  .navbar-actions-with-rfp {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n  }\n\n  .navbar-actions {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-right: 0px !important;\n  }\n\n  .navbar-row {\n    height: auto;\n    padding: 10px 2rem !important;\n  }\n\n  .navbar-mobile {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n  }\n\n  .ant-drawer .ant-drawer-body {\n    padding: 0px;\n  }\n\n  .menu-icon {\n    font-size: xx-large;\n  }\n\n  .login-icon {\n    font-size: large;\n  }\n\n  .navbar-logo {\n    span: 12;\n  }\n\n  .navbar-menu-items {\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-size: var(--Font-Font-Size-h5, 16px);\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n  }\n\n  .user-actions-bar {\n    display: flex;\n    padding-left: 33px !important;\n    align-items: flex-end !important;\n  }\n\n  .navbar-login-btn {\n    width: 100%;\n    margin-top: 10px;\n  }\n\n  .action-icons {\n    height: 23px !important;\n    width: 23px !important;\n  }\n\n  .navbar-link {\n    color: #d2042d;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n  }\n\n  .menu-link {\n    font-size: 1rem;\n  }\n}\n\n.navbar-div {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.navbar-avatar {\n  background: #d2042d;\n  color: #fff;\n}\n.navbar-drawer {\n  display: flex;\n  justify-content: end;\n}\n\n.navbar-actions-row {\n  height: 50px;\n  background-color: #f7f7f7;\n}\n\n.navbar-back-button {\n  padding-left: 1rem;\n  padding-top: 1rem;\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n.custom-advertise-modal.ant-modal .ant-modal-content {\n  padding: 0px !important;\n}\n\n@media (max-width: 576px) {\n  .navbar-menu-items {\n    font-size: 14px;\n  }\n\n  .navbar-actions {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .navbar-text {\n    font-size: 0.75rem;\n  }\n\n  .navbar-login-btn {\n    font-size: 0.875rem;\n  }\n\n  .menu-link {\n    font-size: 1rem;\n  }\n\n  .menu-icon {\n    font-size: large;\n  }\n\n  .navbar-logo {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    padding-left: 1rem;\n  }\n\n  .login-icon {\n    font-size: large;\n    width: 30px;\n  }\n  .navbar-container {\n    width: 100%;\n    position: sticky !important;\n    background-color: white !important;\n    top: 0 !important;\n    left: 0 !important;\n    z-index: 1000 !important;\n    height: 81px;\n  }\n}\n@media (max-width: 768px) {\n  .navbar-logo {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    padding-left: 2rem !important;\n  }\n}\n@media (max-width: 375px) {\n  .submit-your-request-nav-bar {\n    color: #000;\n    font-family: Roboto;\n    font-size: var(--Font-Font-Size-small, 15px) !important;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n  .navbar-link {\n    color: #d2042d;\n    font-size: 16px !important;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n  }\n}\n@media (max-width: 320px) {\n  .navbar-logo {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    padding-left: 0.5rem !important;\n  }\n}\n.rfp-input-field {\n  height: 3.125rem;\n  padding: 0.625rem 1.25rem !important;\n  align-items: center;\n  margin-top: 0;\n  font-size: 14px;\n  border-radius: 0.3125rem !important;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;\n  background: #fcfcfc !important;\n}\n\n.ant-menu-light.ant-menu-root:focus-visible {\n  outline: unset;\n  outline-offset: 1px;\n  transition:\n    outline-offset 0s,\n    outline 0s;\n}\n\n@media (min-width: 1025px) {\n  .navbar-row {\n    padding: 10px 4.37rem !important;\n  }\n}\n\n.chatbox-modal-desktop .ant-drawer .ant-drawer-body {\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  padding: 12px 12px !important;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
